import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import type { SxProps, Theme } from '@mui/material/styles';
import { Fragment, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { clearEnvironmentOverrides } from './clearEnvironmentOverrides.ts';
import { getEnvironmentOverrides } from './getEnvironmentOverrides.ts';

const ALERT_SX: SxProps<Theme> = {
  '& .MuiAlert-action': {
    paddingTop: 0,
  },
  '& .MuiAlert-message': {
    paddingBlock: 0.5,
  },
  alignItems: 'center',
  flexShrink: 0,
  padding: theme => theme.spacing(0, 4),
  width: '100%',
};

export const EnvironmentOverrideBar = () => {
  const { t } = useTranslation();
  const { current: overrides } = useRef(getEnvironmentOverrides());

  if (!overrides.length) {
    return null;
  }

  const handleReset = () => {
    clearEnvironmentOverrides();
    window.location.reload();
  };

  return (
    <Alert
      action={
        <Button
          color="primary"
          data-test="environment-override-reset-button"
          onClick={handleReset}
          size="small"
          variant="text"
        >
          {t('Reset')}
        </Button>
      }
      data-test="environment-override-bar"
      severity="warning"
      sx={ALERT_SX}
    >
      {t('Custom environment:')}{' '}
      {overrides.map(({ label, name, value }, index) => (
        <Fragment key={name}>
          {index > 0 && ' · '}
          <span data-test={`environment-override-item-${name}`}>
            {label}: <b>{value}</b>
          </span>
        </Fragment>
      ))}
    </Alert>
  );
};
